import SignUp from "../modules/SignUp/index";

function SignUpPage() {
  return (
    <div className="mx-[24px]">
      <SignUp />
    </div>
  );
}

export default SignUpPage;
